var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import iconDropdownUpGray from "../assets/icons/Arrow Simple/Up.svg";
import iconDropdownDownGray from "../assets/icons/Arrow Simple/Down.svg";
const badgeColorClass = (state, color) => {
    // Overrides based on SAP colors. Brittle, but should do the basic job
    switch (color === null || color === void 0 ? void 0 : color.toLowerCase()) {
        case "#ffc000":
            return "warning";
        case "#ff0000":
            return "danger";
        case "#00b050":
            return "success";
    }
    // "Default" mapping based on state. Works pretty much like a fallback.
    switch (state) {
        case "in_progress":
            return "success";
        case "done":
            return "inactive";
        case "rejected":
            return "danger";
        default:
            return "";
    }
};
const badge = (label, state, color) => {
    return (React.createElement("span", { className: "mr-4" },
        React.createElement("div", { className: `request-badge rounded ${badgeColorClass(state, color)}` }, label)));
};
const RequestCard = (_a) => {
    var { className, description, number, state, label, color, isOpenByDefault, children, translateFunc } = _a, props = __rest(_a, ["className", "description", "number", "state", "label", "color", "isOpenByDefault", "children", "translateFunc"]);
    const [isOpen, setIsOpen] = useState(isOpenByDefault || false);
    const arrowIcon = (React.createElement("img", { className: "mr-2", width: "26", height: "26", draggable: false, src: isOpen ? iconDropdownUpGray : iconDropdownDownGray, "aria-hidden": "true" }));
    return (React.createElement("div", { className: "request-card-body rounded" },
        React.createElement(Row, { as: "button", type: "button", className: "request-card-toggle cursor-pointer align-items-start", noGutters: true, onClick: () => setIsOpen(!isOpen) },
            React.createElement(Col, { xs: 11, md: "auto", className: "mb-1 mb-md-0 order-0 mr-lg-3 request-title" },
                React.createElement("h2", { className: "display-4 m-0 text-break", style: { wordWrap: "break-word" } }, description)),
            React.createElement(Col, { xs: 1, lg: "auto", className: "d-flex d-md-none justify-content-end order-md-4" }, arrowIcon),
            React.createElement(Col, { xs: 12, lg: "auto", className: "mb-1 mb-md-0 order-md-3 order-lg-1" },
                React.createElement("span", { className: "request-id" },
                    "(ID ",
                    number,
                    ")")),
            React.createElement(Col, { md: "auto", className: "ml-auto d-flex align-items-center order-md-1 order-lg-3" },
                badge(label, state, color),
                React.createElement("span", { className: "d-none d-md-inline" }, arrowIcon))),
        isOpen && (React.createElement(Row, { className: "mt-3 mb-md-0" },
            React.createElement(Col, { xs: 12 }, children)))));
};
export default RequestCard;
//# sourceMappingURL=index.js.map